function o(n, e, t) {
  const i = {
    event_name: n,
    ...t,
    ...e
  };
  typeof window.utag < "u" && window.utag.link(i);
}
function d(n, e, t) {
  const i = {
    event_name: n,
    ...t,
    ...e
  };
  typeof window.utag < "u" && window.utag.view(i);
}
export {
  o as sendUtagLink,
  d as sendUtagView
};
//# sourceMappingURL=sendEvent.js.map
